export const MAIN_SIDEBAR = 'MAIN_SIDEBAR';
export const SECOND_SIDEBAR = 'SECOND_SIDEBAR';
export const THIRD_SIDEBAR = 'THIRD_SIDEBAR';
export const FORTH_SIDEBAR = 'FORTH_SIDEBAR';
export const FIFTH_SIDEBAR = 'FIFTH_SIDEBAR';

